export const QUESTIONS_LIST = [
    {
        id: 0,
        title:
            'Por quanto tempo você pode deixar o seu dinheiro investido?',
        answersList: [
            {
                id: 1,
                title: 'Sem prazo.',
                goToQuestion: 1,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            },
            {
                id: 2,
                title: 'Até 1 ano.',
                goToQuestion: 1,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            },
            {
                id: 3,
                title: 'Até 3 anos.',
                goToQuestion: 1,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            }
        ]
    },
    {
        id: 1,
        title: 'Qual o seu principal objetivo ao investir?',
        answersList: [
            {
                id: 4,
                title:
                    'Ganhar mais que na poupança, com a mesma segurança.',
                goToQuestion: null,
                isEnd: true,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            },
            {
                id: 5,
                title: 'Ter uma renda mensal.',
                goToQuestion: null,
                isEnd: true,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            },
            {
                id: 6,
                title: 'Construir um patrimônio para garantir o meu futuro e da minha família.',
                goToQuestion: null,
                isEnd: true,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            },
            {
                id: 7,
                title: 'Comprar um bem ou fazer uma viagem.',
                goToQuestion: null,
                isEnd: true,
                classificationPoints: [
                    {
                        name: 'Moderado',
                        points: 50
                    }
                ]
            }
        ],
    },
];

export const SUITABILITY_DESCRITIONS = {
           Moderado:
               `Este perfil busca os altos lucros da Bolsa mas equilibra
               os riscos com investimentos seguros da renda fixa.`,
           Arrojado:
               `Você aceita correr riscos e não tem nenhuma necessidade de
               sacar o investimento no curto ou médio prazo. Se sente confortável
               para lidar com as oscilações do mercado e aceita diversificar
               seus investimentos. `,
           Conservador:
               `Você não gosta de correr riscos e deseja, antes de tudo, preservar
               os seus recursos. Prefere investimentos com rendimento previsível,
               como os de renda fixa e Tesouro Direto.`
       };

export const CUSTOM_WALLET_PAGE_URL = 'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=';
export const CUSTOM_WALLETS_DATASET = [
           // Perfil Agressivo que pretende investir mais de R$50 mil
           {
               name: 'arrojado-3',
               valueRange: [50000, null],
               suitability: 'arrojado',
               link: '/meu-plano-de-investimentos/arrojado-3',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/arrojado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=arrojado1'
               }
           },
           // Perfil arrojado que pretende investir entre R$10 mil e R$50 mil
           {
               name: 'arrojado-2',
               valueRange: [10000.01, 50000],
               suitability: 'arrojado',
               link: '/meu-plano-de-investimentos/arrojado-2',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/arrojado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=arrojado1'
               }
           },
           // Perfil arrojado que pretende investir entre R$5 mil e R$10 mil
           {
               name: 'arrojado-1',
               valueRange: [5000.01, 10000],
               suitability: 'arrojado',
               link: '/meu-plano-de-investimentos/arrojado-1',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/arrojado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=arrojado1'
               }
           },
           // Perfil arrojado que pretende investir menos de R$ 5 mil
           {
               name: 'arrojado-0',
               valueRange: [0, 5000],
               suitability: 'arrojado',
               link: '/meu-plano-de-investimentos/arrojado-0',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/arrojado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=arrojado1'
               }
           },
           // Perfil Moderado que pretende investir mais de R$50 mil
           {
               name: 'moderado-3',
               valueRange: [50000.01, null],
               suitability: 'moderado',
               link: '/meu-plano-de-investimentos/moderado-3',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/moderado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=moderado1'
               }
           },
           // Perfil Moderado que pretende investir entre R$10 mil e R$50 mil
           {
               name: 'moderado-2',
               valueRange: [10000.01, 50000],
               suitability: 'moderado',
               link: '/meu-plano-de-investimentos/moderado-2',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/moderado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=moderado1'
               }
           },
           // Perfil Moderado que pretende investir entre R$5 mil e R$10 mil
           {
               name: 'moderado-1',
               valueRange: [5000.01, 10000],
               suitability: 'moderado',
               link: '/meu-plano-de-investimentos/moderado-1',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/moderado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=moderado1'
               }
           },
           // Perfil Moderado que pretende investir menos de R$ 5 mil
           {
               name: 'moderado-0',
               valueRange: [0, 5000],
               suitability: 'moderado',
               link: '/meu-plano-de-investimentos/moderado-0',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/moderado1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=moderado1'
               }
           },
           // Perfil conservador inicialmente irá para a tela de patrimônio (home logada) sem nem passar pelo fluxo
           {
               name: 'conservador',
               valueRange: [0, 0],
               suitability: 'conservador',
               link: '/meu-plano-de-investimentos/conservador',
               resourceUrls: {
                   data:
                       'https://artigos.toroinvestimentos.com.br/hubfs/landing-pages/hotsites/carteira/conservador1.json',
                   description:
                       'https://artigos.toroinvestimentos.com.br/carteira-personalizada?perfil=conservador1'
               }
           }
       ];
